import { useEffect } from "react";

import { setDefaultSetting } from "../store";

export function useSyncDefaultSettingPeripheral(
    data: any,
    defaultSetting: any
) {
    useEffect(() => {
        if (data.data === undefined) return;
        setDefaultSetting({
            ...defaultSetting,
            peripheral: { data: [...data.data] },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
}
